import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2, Inbox, CloudOff } from "lucide-react";

export default function PresetsList({ presets, onLoad, onDelete, activeId }) {
  return (
    <div
      className="bg-[#111] border border-[#2A2A2A] p-5"
      data-testid="presets-list"
    >
      <div className="flex items-baseline justify-between border-b border-[#2A2A2A] pb-3 mb-4">
        <h3 className="font-display font-bold uppercase tracking-tight text-lg text-white">
          Saved Boards
        </h3>
        <span className="font-mono text-[10px] tracking-[0.3em] text-white/40">
          {presets.length} TOTAL
        </span>
      </div>

      {presets.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-10 text-white/40">
          <Inbox className="w-8 h-8 mb-3" />
          <p className="font-mono text-[11px] uppercase tracking-[0.25em]">
            No saved boards yet
          </p>
        </div>
      ) : (
        <ul className="space-y-2 max-h-[420px] overflow-y-auto no-scrollbar">
          {presets.map((p) => {
            const isActive = activeId === p.id;
            return (
              <li
                key={p.id}
                data-testid={`preset-item-${p.id}`}
                className={`group flex items-center justify-between gap-2 px-3 py-2 border ${
                  isActive ? "border-white bg-[#1a1a1a]" : "border-[#2A2A2A] hover:border-white/40"
                } transition-colors`}
              >
                <button
                  onClick={() => onLoad(p)}
                  className="flex-1 text-left min-w-0"
                  data-testid={`load-preset-${p.id}`}
                >
                  <div className="font-display text-sm text-white truncate flex items-center gap-2">
                    <span className="truncate">{p.name || "(untitled)"}</span>
                    {p._pending && (
                      <span
                        className="inline-flex items-center gap-1 px-1.5 py-0.5 border border-amber-400/60 text-amber-400 font-mono text-[9px] tracking-widest uppercase shrink-0"
                        title="Not synced yet — will upload when back online"
                        data-testid={`pending-badge-${p.id}`}
                      >
                        <CloudOff className="w-2.5 h-2.5" />
                        {p._pending}
                      </span>
                    )}
                  </div>
                  <div className="font-mono text-[10px] text-white/50 uppercase tracking-widest truncate">
                    {(p.line_code || "—")} · {p.destination || "no destination"} · plat {p.platform || "–"}
                  </div>
                </button>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(p)}
                  data-testid={`delete-preset-${p.id}`}
                  className="rounded-none h-8 w-8 text-white/60 hover:text-red-500 hover:bg-transparent"
                  aria-label="Delete preset"
                >
                  <Trash2 className="w-4 h-4" />
                </Button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
